// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_8506d7', '__Inter_Fallback_8506d7'","fontStyle":"normal"},"className":"__className_8506d7","variable":"__variable_8506d7"};